// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lad-tags .el-button.is-unselected:not(:hover){color:#c0c4cc;background-image:none;background-color:#fff;border-color:#ebeef5}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
